import React from 'react';
import Skeleton from 'react-loading-skeleton';

import 'react-loading-skeleton/dist/skeleton.css';
import styles from './LabelLoader.module.scss';

const LabelLoader = ({ widthClass }) => (
  <div className={styles[widthClass]}>
    <Skeleton borderRadius={16} height={10} />
  </div>
);

export default LabelLoader;
